import ApiResponseBase from '../../../../Base/Domain/ApiResponseBase';
import PaymentDetailsModel from '../PaymentDetailsModel';

class GetPaymentsResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.Payments = params.payments?.map(m => new PaymentDetailsModel(m));

  }

}

export default GetPaymentsResponseModel;